import * as URLConfig from "@frameworks/web/config/domain";
import { urlConstructor } from "@frameworks/web/config/domain";
var config = URLConfig.config;
var base = "market/";
var MutualFundsConfigURL = {
    getMutualFundsSchemes: urlConstructor(config.app_mf, base, "summary"),
    // getMutualFundsSchemes: config.jmw + config.app_mf + base + "summary",
    exploreFunds: config.jmw + config.app_mf + base + "mf-sub-categories",
    fundsHouse: config.jmw + config.app_mf + base + "amc-list",
    filterData: urlConstructor(config.app_mf, base, "filter"),
    // filterData: config.jmw + config.app_mf + base + "filter",
    getMutualFundCategory: urlConstructor(config.app_mf, base, "product-hierarchy"),
    // getMutualFundCategory:
    //   config.jmw + config.app_mf + base + "product-hierarchy",
    schemeCategory: urlConstructor(config.app_mf, base, "scheme-category"),
    // schemeCategory: config.jmw + config.app_mf + base + `scheme-category`,
    mFPurchaseSipCta: urlConstructor(config.app_mf, base, "cta"),
};
export default MutualFundsConfigURL;
